import { formatCurrency } from 'utilities/localization';

import { addSaleAttributesToProducts } from '../utilities';

import config from './config';

function getHomePageGenericLayout (result, settings) {

	const {
		imageSize, showTitle, withPrice, maxItemsToDisplay = config.HOME_PAGE_DY_WIDGET_ITEMS_MAX_SLOTS
	} = settings;
	const products = result.Products.map(addSaleAttributesToProducts);
	const boxTitle = result?.BoxTitle || '';
	const maxItems = typeof maxItemsToDisplay === 'number' ? Math.min(products.length, maxItemsToDisplay) : products.length;

	let productItemsHtml = '';

	for (let i = 0; i < maxItems; i += 1) {

		const product = products[i];
		const {
			Url,
			ShortSku,
			ImageBaseUrl,
			SkuInputType,
			ProductName,
			FormattedPrice,
			salePriceSavings,
			saleClassName = '',
			clearanceCalloutText = '',
			saleCalloutText = '',
			SlotId
		} = product;
		const regularPriceCrossedOut =	salePriceSavings > 0 ? ` <span class="regularPriceCrossedOut"> ${formatCurrency(100, '', false)}</span>` : '';

		productItemsHtml += `<div class="dyHomePageWidget__item">
			<a href="${Url}" class="productLink" data-certonaSku="${ShortSku}">
				<img
					src="${ImageBaseUrl}?qlt=55&amp;wid=${imageSize}&amp;hei=${imageSize}&amp;op_sharpen=1&amp;fmt=jpeg"
					data-sku="${ShortSku}" data-sku-input-type="${SkuInputType}" data-slotId="${SlotId}"
					class="productImage" width="${imageSize}" height="${imageSize}" alt="${ProductName}" />
			${showTitle ? `<div class="productName">${ProductName}</div>` : ''}
			${
	withPrice
		? `<div class="productPrice">
				<span class="${saleClassName}">
					${formatCurrency(FormattedPrice)}
					${clearanceCalloutText}${saleCalloutText}
				</span>
		   </div>`
		: ''
}
			</a>
		</div>`;

	}

	for (let j = 0; j < maxItemsToDisplay - maxItems; j += 1) {

		productItemsHtml += '<div class="dyHomePageWidget__item"></div>';

	}

	return `<div class="dyHomePageWidget__header">
			<h2 class="dyHomePageWidget__headerTitle">${boxTitle}</h2>
		</div>
		<div class="dyHomePageWidget__list ">${productItemsHtml}</div>`;

}

export default getHomePageGenericLayout;
